import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GoBackButton from '../elements/GoBackButton';
import PopupTitle from '../elements/PopupTitle';
import GameMaterials from "../elements/GameMaterials";

import apiCall from '../apiCall';
import { dispatchUnreadPopup } from '../../helpers/popupHelper';

class ClassBonusPoints extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
  };
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      gameScores: {},
      assignments: [],
      showBonus: false,
    };
  }

  get game() {
    const { schoolClass } = this.props;
    if (Array.isArray(schoolClass.SchoolClassGames)) {
      const scg = schoolClass.SchoolClassGames.find(g => g.Game.abbreviation === 'BO');
      if (scg) return scg.Game;
    }
    return {};
  }

  componentWillMount() {
    if (!this.game.id) return;
    const { dispatch, project, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if(currentRound <= 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtextraopdrachten_T' : 'mlgvtextraopdrachten_T'), dispatch);
    }
    this.fetchGeneralMaterials();
  }

  fetchGeneralMaterials = () => {
    const { project, schoolClass } = this.props;
    apiCall(`/generalMaterial/${schoolClass.LanguageId}/${project.DefaultDifficultyId}/${this.game.id}`)
      .then((assignments) => {
        this.setState({ assignments });
      });
  };

  render() {
    const { desktop } = this.props;

    return (
      <div className={'classleader-prepare ' + (desktop ? 'portal-home darkBckg desktop-single' : '')}>
        <div className={'container general-materials-container'}>
          <div className={'title-block'}>
            <GoBackButton history={this.props.history} />
            <PopupTitle popupId={this.props.project.difficulty === "PRO" ? 'mhgvtextraopdrachten' : 'mlgvtextraopdrachten'} tag={'h3'} />
            <p>
              {__('sim_bonuspunten')}
            </p>
          </div>
          <GameMaterials items={this.state.assignments} />
        </div>
      </div>
  );
  }
}

export default connect(({project, schoolClass, gameState}) => ({
  project,
  schoolClass,
  gameState
}))(ClassBonusPoints);



// WEBPACK FOOTER //
// ./src/components/routes/ClassBonusPoints.js